import { useCallback, useState } from "react";

export const useSlider = () => {
    const [isShowSlider, setIsShowSlider] = useState(false);
    const openSlider = useCallback(() => setIsShowSlider(true), []);
    const closeSlider = useCallback(() => setIsShowSlider(false), []);

    return { isShowSlider, openSlider, closeSlider }
}